import React from 'react';

import { ICON_NAMES } from '@/config/config';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { SizedIconWithCircle } from '../../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../../shared/components/Text';
import { PayoutsListRowProps } from '../../../types/PayoutsListRowProps';

export const payoutIdFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'id',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    disableOnRowClick: true,
    renderCell: (rowData: PayoutsListRowProps) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.button}
          iconName={ICON_NAMES.PAYOUTS}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_PAYOUT_ID' }}
        />
      );
    },
  };
};
